// How big a quest is, and what kind it is. Each quest in quests.json uses one of each.
export const SIZES = [
  { id: 'side', label: 'side quest', hint: 'an afternoon' },
  { id: 'day', label: 'day quest', hint: 'a full day' },
  { id: 'weekend', label: 'weekend expedition', hint: 'a weekend' },
  { id: 'epic', label: 'epic campaign', hint: 'a big trip' }
];

export const VIBES = [
  { id: 'outdoors', label: 'outdoors', icon: '🌲' },
  { id: 'culture', label: 'culture', icon: '🎭' },
  { id: 'history', label: 'history', icon: '🏛️' },
  { id: 'fun', label: 'just for fun', icon: '🎡' }
];
